import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { TokenModel } from "../token/token"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { Credential, TokenApi } from "../../services/api/token-api"
import moment from "moment"
import config from "../../utils/config"
import { Platform } from "react-native"
import { resetPersistence } from "../../navigators"

/**
 * Model description here for TypeScript hints.
 */
export const TokenStoreModel = types
  .model("TokenStore")
  .props({
    loading: types.maybeNull(types.boolean),
    demo: types.maybeNull(types.boolean),
    token: types.maybeNull(TokenModel),
    cacheKey: types.maybeNull(types.string),
    expiredCacheKey: types.maybeNull(types.number),
    updated_at: types.maybeNull(types.string),
    error: types.maybeNull(types.frozen())
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key, value) {
      self[key] = value
    },
    setLoading: (loading: boolean) => {
      self.loading = loading
    },
    setToken: (token) => {
      self.token = token
      self.updated_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
    },
    setError: (error: any) => {
      self.error = error;
    }
  }))
  .actions((self) => ({
    logout: () => {
      self.token = null
      self.demo = null
      self.updated_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
    }
  }))
  .actions((self) => ({
    async requestToken(credential: Credential) {
      const tokenApi = new TokenApi(self.environment.api)
      self.setLoading(true)
      const result = await tokenApi.requestToken(credential)
      self.setLoading(false)
      if (result.kind === 'ok') {
        self.setError(null)
        self.setToken(result.token)
      } else {
        // __DEV__ && console.tron.log(result.kind)
        self.setToken(null)
        self.setError(result)
      }
    },
    async requestCacheKey() {
      const currentDate = new Date()
      if (self.expiredCacheKey > currentDate.getTime()) {
        return Promise.resolve(true)
      }
      return self.axios.post('/request_access')
        .then((response) => {
          self.set('expiredCacheKey', currentDate.getTime() + (110 * 60 * 1000))
          self.set('cacheKey', response.data.data.cache_key);
          return response;
        })
    },
    async requestTokenByCacheKey(cacheKey: string) {
      if (Platform.OS !== 'web') throw new Error('Only Applicable from Web');

      const { OAUTH2_URL, CLIENT_ID } = config();
      const url = new URL(`${OAUTH2_URL}/authorize`);
      const searchParams = new URLSearchParams()
      searchParams.set('client_id', CLIENT_ID);
      searchParams.set('redirect_uri', `${window.location.origin}/`);
      searchParams.set('response_type', 'token');
      searchParams.set('scope', '*');
      searchParams.set('cache_key', cacheKey);
      url.search = searchParams.toString();

      window.location.href = url.toString();
      resetPersistence();
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type TokenStoreType = Instance<typeof TokenStoreModel>
export interface TokenStore extends TokenStoreType {}
type TokenStoreSnapshotType = SnapshotOut<typeof TokenStoreModel>
export interface TokenStoreSnapshot extends TokenStoreSnapshotType {}
export const createTokenStoreDefaultModel = () => types.optional(TokenStoreModel, {})
